import get from 'transmute/get';
export const getIdentified = get('identified');